module.exports = __webpack_public_path__ + "img/avatar-3.f347a73e.png";